export class UserFilterModel {

    public search: string;
    public status: number;
    public role: number;
    public organizationId: number;
    public RegistrationDateStart: Date;
    public RegistrationDateEnd: Date;
    public LastActivityDateStart: Date;
    public LastActivityDateEnd: Date;
    public division: string;

}


// WEBPACK FOOTER //
// ./src/app/core/models/userFilter.model.ts